import { render, staticRenderFns } from "./rechargeCenterGoods.form.vue?vue&type=template&id=132416bd&scoped=true&lang=pug"
import script from "./rechargeCenterGoods.form.vue?vue&type=script&lang=js"
export * from "./rechargeCenterGoods.form.vue?vue&type=script&lang=js"
import style0 from "./rechargeCenterGoods.form.vue?vue&type=style&index=0&id=132416bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132416bd",
  null
  
)

export default component.exports